<template>
  <div v-if="seat">
    <v-circle
        @mousedown="select"
        @mouseover="mouseover"
        :config="{
              x: x,
              y: y,
              id: seat.id,
              radius: 25,
              fill: this.color,
              opacity: 0.8,
              draggable: false,
              scaleX: 1,
              scaleY: 1,
              shadowColor: 'black',
              shadowBlur: 10,
              shadowOpacity: 0.6,
            }"
    ></v-circle>
  </div>
</template>

<script>
export default {
  name: "Seat",
  props: {
    x: {
      type: Number,
    },
    y: {
      type: Number,
    },
    seat: {
      type: Object,
      default: null,
    },
    defaultSelected: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    }
  },
  data: () => ({
    selected: false,
  }),
  mounted() {
    this.selected = this.defaultSelected;
  },
  computed: {
    color (){
      if(this.selected){
        return "#FFFF00";
      }
      if(this.seat.owner && !this.selected){
        return "#007bff"
      }
      if(this.seat.stateId == 3){
        return "#00FF00"
      }
      return "#FF0000"
    }
  },
  methods: {
    mouseover(){
      this.$emit('hover', this.seat);
    },
    select() {
      //if(seat.blocked)
      //  return;
      if(this.seat.stateId < 3 || this.seat.orderId >= 0 && this.seat.orderId != this.order.id){
        return;
      }
      this.selected = !this.selected;
      if(this.selected){
        this.$emit('selected', this.seat.id);
      } else {
        this.$emit('deselected', this.seat.id)
      }
      //this.generateInfo();
    },
  }
}
</script>

<style scoped>

</style>